export enum FAILURE_REASON {
	API_FAIL = 'api fail',
	AUP_VIOLATION = 'aup violation detected',
	UNKNOWN = 'unknown fail',
	TOKEN_LIMIT = 'token limit fail',
	INSERT_FAILURE = 'insert failure',
	INPUT_TOO_SHORT = 'input too short fail',
	HIPAA_CONTENT = 'hipaa content fail',
	RATE_LIMITED = 'rate limited',
	INTERNAL_SERVER_ERROR = 'internal server error',
	ELEVATE_DISABLED_GENERATE = 'elevate disabled generate',
	// duplicates, only used for displaying error text in the command palette under fg('platform_editor_ai_in_document_streaming')
	CMD_PALETTE_API_FAIL = 'api fail in command palette',
	CMD_PALETTE_AUP_VIOLATION = 'aup violation detected in command palette',
}
